import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/salary-period";

export const searchByPageSalaryPeriod = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const getSalaryPeriodById = (serviceVatId) => axios.get(API_PATH + "/get-by-id/" + serviceVatId);

export const saveOrUpdateSalaryPeriod = serviceVat => axios.post(API_PATH + "/save-or-update", serviceVat);

export const deleteSalaryPeriod = serviceVatId => axios.delete(API_PATH + '/mark-delete/' + serviceVatId);

export const saveSalaryPeriodSyncSalaryPeriodHRM = (searchObject) => axios.post(API_PATH + "/sync-salary-period-from-HRM", searchObject);